import styled from 'styled-components'

export const BlogView = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const HeaderWrapper = styled.div`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
`

export const BlogCoverImage = styled.img`
  width: 100%;
  object-fit: cover;
`

export const BlogContent = styled.div`
  width: 70%;
  max-width: 1250px;
  padding: 40px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 1150px) {
    width: 100%;
    padding: 0;
    margin-top: 33px;
  }
`

export const BlogPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BlogWidgets = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${props => (props.topSpacing ? '34px' : '0')};
  margin-bottom: 50px;
  width: 100%;
  max-width: 1250px;

  ${props =>
    !props.fullLength &&
    `
    & > div {
      width: 49%;
    }
  `}

  @media (max-width: 1150px) {
    flex-direction: column;
    margin-left: 15px;
    margin-right: 15px;
    width: auto;
    max-width: 100%;

    & > div {
      width: 100%;
      max-width: 100vw;
      margin-bottom: 34px;
    }
  }
`

export const InstagramWidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #f2f7fa;
  box-shadow: 0px 0px 3px #f2f7fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const InstagramWidgetFrame = styled.iframe`
  border: none;
  overflow: auto;
  width: 90%;
  box-sizing: border-box;
  height: 180px;

  @media (max-width: 1150px) {
    height: 105px;
  }
`

export const InstagramTitle = styled.div`
  display: block;
  font-weight: 700;
  font-size: 22px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #000000;
  margin-bottom: 29px;

  & > img {
    vertical-align: middle;
  }
`

export const CategoryInfo = styled.div`
  max-width: 912px;
  text-align: center;

  & h1 {
    font-weight: 500;
    font-size: 40px;
    line-height: 49px;
    color: #000000;
    margin-bottom: 20px;
  }

  & p {
    margin-top: 0;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #969ea5;
  }

  @media (max-width: 1150px) {
    width: 100%;
    font-weight: 500;

    & h2 {
      font-size: 24px;
      line-height: 29px;
      margin-bottom: 15px;
      margin-top: 38px;
    }

    & p {
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #969ea5;
    }
  }
`
